<template :data-type="order.type">
  <div class="card__content fg-1">
    <div class="grid grid--spacing2 grid--row">
      <div class="grid__item fb-0">
        <div class="orderCard__data">
          <div class="orderCard__icon">
            <template v-if="order.type === 'RECURRING'"><icon-rotate-cw></icon-rotate-cw></template>
            <template v-if="order.type === 'ONE_OFF' && order.is_gift === 0"><icon-play></icon-play></template>
            <template v-if="order.type === 'ONE_OFF' && order.is_gift === 1"><icon-gift></icon-gift></template>
          </div>
          <p class="orderCard__text overline text--bold">
            <template v-if="order.type === 'ONE_OFF' && order.is_gift === 1">Gift</template>
            <template v-else>{{ order.type | orderTypeToLabel }}</template>
          </p>
        </div>
        <div class="orderCard__data">
          <div class="orderCard__icon">
            <template v-if="order.drop_method === 'DROP_OFF'"><icon-home></icon-home></template>
            <template v-if="order.drop_method === 'HAND_TO_HAND'"><icon-hand></icon-hand></template>
          </div>
          <p class="orderCard__text overline">{{ order.drop_method | orderTypeToLabel }}</p>
        </div>
      </div>
      <div class="grid__item fb-0">
        <div class="orderCard__data">
          <div class="orderCard__icon"><icon-calendar></icon-calendar></div>
          <p class="orderCard__text overline text--regular">{{ order.date_delivery | dateFormat }}</p>
        </div>
        <div class="orderCard__data">
          <div class="orderCard__icon"><icon-clock></icon-clock></div>
          <p class="orderCard__text overline text--regular">
            {{ order.time_slot.humanized_slot }}
            <span v-if="showETA(order)"><br>(ETA: {{ order.estimated_arrival_at | moment('HH:mm') }})</span>
          </p>
        </div>
      </div>
      <div class="grid__item fg-1">
        <div class="productIcons">
          <template v-for="item in order.items">
            <product-item :product="item" :key="item.id"></product-item>
          </template>
        </div>
      </div>
      <template v-if="status === true">
        <div class="grid__item grid--jcCenter fb-0">
          <p class="tag tag--success" v-if="order.status == 'FINALIZED'">{{ order.status | statusToLabel }}</p>
          <p class="tag tag--error" v-else-if="order.status == 'CANCELED'">{{ order.status | statusToLabel }}</p>
          <p class="tag tag--error" v-else-if="order.status == 'DELIVERY_ISSUE'">{{ order.status | statusToLabel }}</p>
          <p class="tag tag--warning" v-else>{{ order.status | statusToLabel }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ['order', 'status'],

  data() {
    return {
      currentDate: moment().format('YYYYMMDD'),
      currentHour: moment().format('HH')
    }
  },

  methods: {
    showETA(order) {
      const showEstimatedArrivalFrom = moment(order.date_delivery).subtract(7, 'hours');
      return moment() >= showEstimatedArrivalFrom;
    }
  }
}
</script>
